import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import ContactUsCard from '../components/ContactUsCard/ContactUsCard'
import ContactFormModal from '../components/ContactFormModal/ContactFormModal'
import ErrorComponent from '../components/ErrorComponent/ErrorComponent'
import ToastMessage from '../components/ui/ToastMessage/ToastMessage'
import useFetch from '../hooks/useFetch'

function ContactUs() {
  const [searchParams] = useSearchParams()

  // Get specific query parameter
  const form = searchParams.get('form') || ''

  const { data, loading, error } = useFetch('contact-us', (resp) => resp)

  const contactData = data?.data

  const breadcrumbs = contactData?.bread_crumbs
  const pageTitle = contactData?.pageTitle

  const [openModal, setOpenModal] = useState(form === 'open' ? true : false) //make it initially false
  const [openPop, setOpenPopup] = useState(false)
  const [message, setMessage] = useState('')
  const handleView = (contactDetail) => {
    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  const onSubmitResponse = (message) => {
    closeModal()
    setMessage(message)
    setOpenPopup(true)
  }

  if (loading) {
    return (
      <div className="flex justify-center mt-8">
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {error?.hasError ? (
        <div className="flex justify-center">
          <ErrorComponent errorMessage={error.errorMessage} />
        </div>
      ) : (
        <>
          <>
            <div className="page-header text-center mb-6 md:mb-20 page-title-padding">
              {pageTitle}
            </div>
            <ContactUsCard contactData={contactData} handleView={handleView} />
          </>
          {openModal && (
            <ContactFormModal
              open={openModal}
              contactForm={contactData?.sectiondata?.contactusform || []}
              onClose={closeModal}
              onSubmitResponse={onSubmitResponse}
              button={contactData?.sectiondata?.button}
              note={contactData?.sectiondata?.formNote}
            />
          )}
          {openPop && (
            <ToastMessage
              message={message}
              onHide={() => setOpenPopup(false)}
            />
          )}
          <Breadcrumbs
            breadcrumbs={breadcrumbs}
            // className={'sticky bottom-0'}
          />
        </>
      )}
    </>
  )
}

export default ContactUs
